var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-double-ring",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius}}",
    "ng-attr-stroke-width": "{{config.width}}",
    "ng-attr-stroke": "{{config.c1}}",
    "ng-attr-stroke-dasharray": "{{config.dasharray}}",
    fill: "none",
    strokeLinecap: "round",
    r: 40,
    strokeWidth: 10,
    stroke: "#109ad7",
    strokeDasharray: "62.83185307179586 62.83185307179586",
    transform: "rotate(308.533 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "2.1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius2}}",
    "ng-attr-stroke-width": "{{config.width}}",
    "ng-attr-stroke": "{{config.c2}}",
    "ng-attr-stroke-dasharray": "{{config.dasharray2}}",
    "ng-attr-stroke-dashoffset": "{{config.dashoffset2}}",
    fill: "none",
    strokeLinecap: "round",
    r: 29,
    strokeWidth: 10,
    stroke: "#fdfdfe",
    strokeDasharray: "45.553093477052 45.553093477052",
    strokeDashoffset: 45.553093477052,
    transform: "rotate(-308.533 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;-360 50 50",
    keyTimes: "0;1",
    dur: "2.1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.02981499ba9d034b9b6cf248d7d24008.svg";
export { ForwardRef as ReactComponent };